// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes fadeInOut{0%{opacity:.5}50%{opacity:1}100%{opacity:.5}}.content-placeholder{animation:fadeInOut 1.6s cubic-bezier(0.02, 0.01, 0.21, 1) infinite;background:linear-gradient(90deg, #d4dae3 0%, #d4dae3 96.98%);border-radius:4px}.content-placeholder--square{border-radius:4px;height:24px;width:24px}.content-placeholder--circle{border-radius:100%;height:24px;width:24px}.content-placeholder--pill{border-radius:99999px;height:16px;width:100%}", ""]);
// Exports
module.exports = exports;
